import { useTranslation } from "react-i18next";

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <div className="mb-10">
          <img
            src="https://readdy.ai/api/search-image?query=Minimalist%20desk%20workspace%20with%20laptop%20displaying%20clean%20spreadsheet%20data%20interface%20alongside%20a%20steaming%20coffee%20cup%2C%20soft%20cream%20beige%20wall%20background%20with%20subtle%20texture%2C%20warm%20morning%20light%20through%20sheer%20curtains%2C%20modern%20Scandinavian%20style%20home%20office%2C%20calm%20productive%20atmosphere%2C%20editorial%20product%20photography&width=800&height=500&seq=about-v2-8b2f1e&orientation=landscape"
            alt="USFansSpreadsheet interfejs i funkcje"
            className="w-full max-w-lg mx-auto rounded-lg object-cover"
            loading="lazy"
          />
        </div>
        <span className="inline-block text-accent-600 text-sm font-medium tracking-wide uppercase mb-4">
          {t("about.label")}
        </span>
        <p className="text-foreground-700 text-base md:text-lg leading-relaxed">
          {t("about.description")}
        </p>
      </div>
    </section>
  );
}